import { render } from "./DashboardMenus.vue?vue&type=template&id=12f4077a"
import script from "./DashboardMenus.vue?vue&type=script&lang=js"
export * from "./DashboardMenus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__